<script setup lang="ts">
import { defineAsyncComponent, ref, withDefaults, onUnmounted } from 'vue'
import BreadCrumbs from 'Common/components/elements/navigation/BreadCrumbs.vue'
import { BreadCrumbNavigationLayoutType } from 'Common/types/utils/breadCrumbNavigationLayoutType'
import type { BreadCrumbItem } from 'Common/types/utils/breadCrumbItem'

interface PropTypes {
  items: Array<BreadCrumbItem>
  layout?: BreadCrumbNavigationLayoutType
}

const props = withDefaults(defineProps<PropTypes>(), {
  layout: BreadCrumbNavigationLayoutType.BreadCrumbNavigationLayout,
})
const layout = defineAsyncComponent(() => import(`Common/components/layouts/${props.layout}.vue`))
const layoutRef = ref()

onUnmounted(() => {
  layoutRef.value = null
})
</script>

<template>
  <component :is="layout" ref="layoutRef">
    <template #bread-crumbs>
      <slot name="bread-crumbs">
        <BreadCrumbs :items="props.items" :label-style="layoutRef?.breadCrumbStyle" />
      </slot>
    </template>
    <template #main-content>
      <slot name="main-content" />
    </template>
  </component>
</template>
